import { useEffect } from 'react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';
import * as SentryMethods from '@sentry/react';
import { config } from 'config';

SentryMethods.init({
    dsn: 'https://8cd57bab3852088ebcf909b387b5bf34@sentry.k42.dev/28',
    tunnel: `${config.api.url}/${config.api.endpoints.sentryTunnel}`,
    integrations: [
        SentryMethods.reactRouterV6BrowserTracingIntegration({
            useEffect,
            useLocation,
            createRoutesFromChildren,
            useNavigationType,
            matchRoutes,
        }),
        SentryMethods.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    enabled: ['main', 'development'].includes(process.env.VITE_MODE || 'local'),
    environment: process.env.VITE_MODE || 'local',
    tracePropagationTargets: ['localhost', config.api.url],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
});
